var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"animation-button",style:({
    bottom: _vm.animationButton.position.bottom + '%',
    left: _vm.animationButton.position.left + '%'
  }),on:{"click":_vm.animationSelected}},[_c('p',{staticClass:"font--semibold animation-button__title"},[_vm._v(_vm._s(_vm.animationButton.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }